import React from 'react';
import './EmailConfirmation.scss';
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import {navigate} from "@reach/router";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import routes from "../../utils/api-client";
import iziToast from "izitoast";


function EmailConfirmation(props) {
  props.toggleLoading(false);

  if (props.user && props.user.emailVerified) {
    navigate("/vaults")
  }

  const openLiveChat = () => {
    window.driftApi.widget.show();
    window.driftApi.sidebar.open();
  };

  const resendEmail = () => {
    routes.resendVerificationEmail().subscribe((response) => {
      if (response.status === 200) {
        iziToast.success({
          position: "topCenter",
          'title': 'Success',
          'message': 'The verification email has be re-sent.'
        });
      }
    })
  };


  return (
    !!props.user &&
    <div className="flex justify-center email-confirmation">
      <Card className="email-confirmation-card flex flex-col text-center sm:mt-8">
        <FontAwesomeIcon icon="envelope" className="text-primary mx-auto email-icon"/>
        <b className="text-2xl sm:text-4xl">Please verify your email.</b>
        <hr className="light-grey w-3/4 sm:w-1/2 mx-auto my-3"/>
        <p className="mt-2">Thanks for signing up to Fidelius! You're almost there.</p>
        <p className="mt-3">An email has been sent to <span className="font-bold">{ props.user.email }</span>. Just click on the link in that email to complete your signup.</p>
        <p className="mt-3"><span className="font-bold">Note:</span> You may need to check your spam folder for the email.</p>
        <hr className="light-grey w-3/4 sm:w-1/2 mx-auto my-5"/>
        <p className="text-sm sm:text-base text-grey">Still don't see it?</p>
        <div className="mt-2">
          <Button
            variant="outlined"
            color="secondary"
            className="text-secondary resend-email-button"
            onClick={resendEmail}
          > Resend Email
          </Button>
        </div>
        <p className="mt-4 text-sm sm:text-base text-grey">Need help? Contact us via <a href="mailto:support@fideliusvaults.com?Subject=Fidelius Help">email</a> or <a onClick={openLiveChat}>chat</a>.</p>
      </Card>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};


export default compose(
  connect(
    mapStateToProps,
    { toggleLoading }
  )
)(EmailConfirmation);
